import { cn } from "@/lib/utils";

interface OptionCardGridProps {
  label: string;
  options: string[];
  selected: string;
  onSelect: (val: string) => void;
}

export const OptionCardGrid = ({ label, options, selected, onSelect }: OptionCardGridProps) => {
  return (
    <div className="space-y-2.5">
      <h3 className="text-sm font-medium text-muted-foreground">{label}</h3>
      <div className="grid grid-cols-2 gap-2">
        {options.map((opt) => {
          const isSelected = selected === opt;
          return (
            <button
              key={opt}
              onClick={() => onSelect(opt)}
              className={cn(
                "p-3 rounded-xl text-sm transition-all border text-left flex items-center min-h-[60px]",
                isSelected 
                  ? "border-primary bg-primary/5 font-semibold text-primary" 
                  : "border-border bg-background hover:border-primary/40 text-foreground"
              )}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
};
